<template>
    <div ref="record">
        <div class="container">
            <div class="handle-box">
                <el-row :gutter="10" style="margin-bottom:10px">
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="4">
                        <span class="label">邮&emsp;&emsp;箱</span>
                        <el-input size="mini" v-model="searchParam.email" placeholder="邮箱" clearable @clear="searchParam.chName = null" class="handle-input"></el-input>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="4">
                        <span class="label">身份证号码</span>
                        <el-input size="mini" v-model="searchParam.certNo" placeholder="身份证号码" clearable @clear="searchParam.certNo = null" class="handle-input"></el-input>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
                        <span class="label">导入时间</span>
                        <el-date-picker
                            size="mini"
                            style="width:200px"
                            v-model="searchParam.startTime"
                            type="datetime"
                            placeholder="开始时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="'00:00:00'">
                        </el-date-picker>
                        <span class="label" style="margin:0 5px;">至</span>
                        <el-date-picker
                            size="mini"
                            style="handle-input"
                            v-model="searchParam.endTime"
                            type="datetime"
                            placeholder="结束时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="'00:00:00'">
                        </el-date-picker>
                    </el-col>
                </el-row>
                <el-row type="flex"  justify="end">
                    <el-button size="mini" type="primary" icon="el-icon-search" @click="getData">搜索</el-button>
                </el-row>
            </div>
            <el-table :data="tableData" border stripe style="width: 100%" size="mini" :max-height="tableLen">
                <el-table-column prop="createTime" label="导入时间" width="150" align="center"></el-table-column>
                <el-table-column prop="certNo" label="身份证号码" width="400"></el-table-column>
                <el-table-column prop="email" label="邮箱" width="150"></el-table-column>
                <el-table-column prop="subject.name" label="科目" width="120" ></el-table-column>
                <el-table-column prop="reason" label="原因"></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination @current-change="getData" :current-page.sync="searchParam.pageNum" :page-size.sync="searchParam.pageSize" layout="total,sizes,prev, pager, next" :total="totalNumber">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name:'record',
        data() {
            return {
                tableLen:350,
                searchParam:{
                    pageNum:1,
                    pageSize:10,
                    level:'',
                },
                tableData:[],
                totalNumber:0,
            };
        },
        created(){
            this.getData();
        },
        updated() {
            this.tableLen=window.innerHeight-135;
        },
        methods: {
            async getData(){
                let res = await this.$axios.post('/manage/exception/selectByPage',this.searchParam);
                if (res.code != 200) {
                    this.$message.error(res.errMsg);
                    return;
                }

                this.tableData = res.data.list;
                this.totalNumber = res.data.total;
            }
        }
    };
</script>

<style scoped>
.handle-box {
    margin-bottom: 10px;
}
.el-col{
    margin: 10px 0;
}
.label {
    margin-right: 10px;
    color: #606266;
}
</style>
